import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Divider,
  Flex,
  Skeleton,
  Stack,
  Text,
} from '@chakra-ui/react';

import { useQuery } from 'react-query';
import { fetchPickups } from 'api/pickup';

import { scrollbarStyles } from 'theme';

import { convertUTCToLocal } from 'utils/dateUtils';
import { selectors } from 'store/slices/washhub';

import { AnimatePresence, motion } from 'framer-motion';

import { Status } from 'types/items';
import { PendingCountsProps } from './PendingCounts.props';
const MotionFlex = motion(Flex);

const getMotionProps = (index: number) => ({
  initial: {
    opacity: 0,
    scale: 0.5,
  },
  animate: {
    opacity: 1,
    scale: 1,
  },
  transition: {
    delay: 0.03 * index,
    ease: 'easeInOut',
    duration: 0.3,
  },
  exit: {
    opacity: 0,
    scale: 0.5,
  },
});

const PendingCountsView: FC<PendingCountsProps> = (props) => {
  const usePendingCountsQuery = () => {
    // If it's necessary to use the current week data, there is the useCurrentWeek() hook.

    const washHubId = selectors.useSelectedWashHubId();

    const queryKey = [`fetch-pickups-${washHubId}`];

    const queryFn = async () => {
      const pickupsReponse = await fetchPickups({
        status: Status.PENDING_COUNT,
        washHub: washHubId,
      });
      return pickupsReponse;
    };

    const query = useQuery(queryKey, queryFn);

    return query;
  };
  const { data, isLoading } = usePendingCountsQuery();
  // useEffect(() => {
  //   console.log(history.location.search === '?showPending');
  //   const showPending = history.location.search === '?showPending';
  //   setSelectedTabIndex(showPending ? 2 : 0);
  // }, [history.location]);
  const washHubId = selectors.useSelectedWashHubId();
  const navigateUrl = `/pickups?washHubId=${washHubId}&defaultIndex=3`;

  const isEmpty = data?.items.length === 0;

  return (
    <Flex
      p="10px"
      pl="20px"
      minW="300px"
      h="100%"
      bg="#fff"
      minH="480px"
      maxH="480px"
      overflowY="auto"
      css={scrollbarStyles}
      flex={1}
      gap="20px"
      direction="column"
      borderRadius="10px"
      borderWidth="1px">
      <Flex justifyContent="space-between" alignItems="center" w="100%">
        <Text fontSize="22px" fontWeight="600" color="primary.200">
          Pending Counts ({data?.total ?? 0})
        </Text>
        <Button
          as={RouterLink}
          to={navigateUrl}
          colorScheme="teal"
          backgroundColor="transparent"
          variant="link">
          View All
        </Button>
      </Flex>

      {isLoading ? (
        <>
          <Skeleton height="150px" />
          <Skeleton height="150px" />
          <Skeleton height="150px" />
        </>
      ) : isEmpty ? (
        <Text ml="10px">No Pickups for the week</Text>
      ) : (
        <AnimatePresence exitBeforeEnter>
          {data?.items.map((pickup) => (
            <MotionFlex
              bg="#fff"
              key={pickup._id}
              boxShadow="0 0 10px 0 rgba(0,0,0,0.1)"
              p="10px"
              pr="20px"
              pb="20px"
              borderRadius="10px"
              direction="column"
              {...getMotionProps(0)}>
              <Flex gap="10px" align="center">
                <Box h="15px" w="15px" borderRadius="15px" bg="#00BF13" />
                <Text noOfLines={1}>
                  {(pickup.collectionPoint as any)?.name || ''}
                </Text>
              </Flex>
              <Divider my="5px" borderColor="#ccc" />

              <Stack mt="10px" ml="25px" spacing={0} fontSize="14px">
                <Text>Pickup No: {pickup.pickupNumber || '-'}</Text>
                <Text>
                  Pickup Date: {convertUTCToLocal(pickup?.date, true, true)}
                </Text>
                <Text>Event Name: {pickup?.eventName || '-'}</Text>
                <Text>Notes: {pickup.notes || '-'}</Text>
              </Stack>
            </MotionFlex>
          ))}
        </AnimatePresence>
      )}
    </Flex>
  );
};

export default PendingCountsView;
